import React from 'react'
import  Main from './navigation/Main'
import {getAuth, GoogleAuthProvider, signInWithPopup} from 'firebase/auth'
import { useAuthState } from 'react-firebase-hooks/auth';
import Landing from './screen/Landing'
import config from './firebase/config'
import './App.css'

const auth = getAuth()
const provider = new GoogleAuthProvider()

const signIn = ()=>{
  signInWithPopup(auth, provider)
  .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
  }).catch((error) => {
      console.log(error);
  });
}


function App() {
  const [user] = useAuthState(auth)
  return (
    <div>
          {user === null ? 
          <div>
             { /*<button onClick={signIn} id="login-btn">Login</button>*/}
                <Landing  signIn= {signIn}/>
          </div>:<Main />}
    </div>
  )
}

export default App
